/**
 * Checklist types for timeline
 */

export interface ChecklistTimelineItem {
	_id: string
	created: string
	data: ChecklistTimelineItemData
}

export interface ChecklistTimelineItemData {
	coachName: string
	checklist: ChecklistItemData
}

export interface ChecklistItemData {
	template: string
	items: Array<ChecklistTimelineItemDataField>
	modified: string
}

export interface ChecklistTimelineItemDataField {
	id: string
	value: string
}

/**
 * Type for checklist timeline row
 */

export interface ChecklistDisplayDataItem
	extends ChecklistTimelineItemDataField {
	[key: string]: any
	label: string
	checkbox: boolean
	text?: Array<{
		id: string
		placeholder: string
	}>
}

/**
 *  Response result for getting patient checklist values
 */

export interface ChecklistForPatientSelectedFieldsInfo {
	_id: string
	template: string
	patientId: string
	items: Array<ChecklistForPatientSelectedFieldsInfoItem>
}

export interface ChecklistForPatientSelectedFieldsInfoItem
	extends ChecklistTimelineItemDataField {
	smartGoal1?: string
	smartGoal2?: string
	systolic?: string
	diastolic?: string
	comorbiditiesType?: string
	otherGoals?: string
	hba1cDate?: string
	treatmentType?: string
	conditionManagementImportance?: string
	conditionManagementConfidence?: string
}

/**
 * Checklist form type
 */

export interface ChecklistEditFormData {
	[key: string]: ChecklistForPatientSelectedFieldsInfoItem
}

/**
 * Checklist edit request data
 */

export interface ChecklistEditRequestData {
	checklist: {
		template: string
		items: Array<ChecklistForPatientSelectedFieldsInfoItem>
	}
	timer: {
		type: string
		start: string
		end: string
	}
}

/**
 *  Checklist store types
 */

export interface ChecklistState {
	checklistTimeline: Array<ChecklistTimelineItem>
	count: number
}

export enum CHECKLIST_ACTION_TYPES {
	CHECKLIST_TIMELINE_GET = 'CHECKLIST_TIMELINE_GET',
	CHECKLIST_TIMELINE_GET_MORE = 'CHECKLIST_TIMELINE_GET_MORE',
	CHECKLIST_TIMELINE_EDIT_ITEM = 'CHECKLIST_TIMELINE_EDIT_ITEM',
}

interface ChecklistGetTimelineAction {
	type:
		| CHECKLIST_ACTION_TYPES.CHECKLIST_TIMELINE_GET
		| CHECKLIST_ACTION_TYPES.CHECKLIST_TIMELINE_GET_MORE
	payload: {
		paginatedResults: Array<ChecklistTimelineItem>
		totalCount: Array<{ count: number }>
	}
}

interface ChecklistTimelineEditItem {
	type: CHECKLIST_ACTION_TYPES.CHECKLIST_TIMELINE_EDIT_ITEM
	payload: ChecklistTimelineItem
}

export type ChecklistActionTypes =
	| ChecklistGetTimelineAction
	| ChecklistTimelineEditItem
